var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-735d508e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./png.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/png.vue
// module id = 1012
// module chunks = 2